// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
    min-height: 100vh;
    max-width: 100vw;
    background: rgb(36, 36, 36);
    background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#242424", endColorstr="#2d2d2d", GradientType=1);
    padding-bottom: 10px;
    display: flex;
    align-items: center;
}

.bold {
    margin-left: -5px;
    font-weight: bold;
    text-decoration: underline;
}

.about h1 {
    padding-top: 30px;
    text-align: center;
    background-image: linear-gradient(to left, #ffffff, #6d6a70);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    font-size: 4rem;
    font-weight: 400;
}

.about h2,
.about h3 {
    background-image: linear-gradient(to left, #9873bb, #9f89b4);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    text-align: center;
}

.about h4 {
    background-image: linear-gradient(to left, #d9cfe2, #d3b5f0);
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    text-align: center;
    font-size: 1.2em;
    line-height: 40psxx;
}

.about p {
    color: #f1faee;
    font-family: 'Cabin', sans-serif;
    font-size: 1rem;
}

.about img {
    height: 40px;
}

.about span {
    font-family: 'Cabin', sans-serif;
    font-size: 1rem;
}

.social,
.skills-container {
    padding-bottom: 40px;
    box-shadow: 0 1em 1em -1em rgba(0, 0, 0, .45);
    text-align: center;
}

.social img {
    margin: 20px;
}

.social img:hover {
    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(319deg) brightness(102%) contrast(101%);
}

.toast {
    display: block;
    margin-left: auto;
    margin-right: auto;
    background-color: rgba(137, 132, 132, 0.361) !important;
    color: white;
}

.toast:hover {
    background-color: rgba(137, 132, 132, 0.500) !important;
}

.toast-body img {
    margin: auto;
    display: block;
}

.toast-body span {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}

.skills {
    margin-bottom: 1rem;
}

@media screen and (max-width: 850px) {

    .about h1,
    .about h2 {
        padding-top: 2vh;
    }

    .about p {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/about.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAG3B,oFAAoF;IACpF,kHAAkH;IAClH,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;IAEI,oBAAoB;IACpB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gGAAgG;AACpG;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uDAAuD;IACvD,YAAY;AAChB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".about {\r\n    min-height: 100vh;\r\n    max-width: 100vw;\r\n    background: rgb(36, 36, 36);\r\n    background: -moz-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    background: -webkit-linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    background: linear-gradient(90deg, rgba(36, 36, 36, 1) 28%, rgba(45, 45, 45, 1) 66%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#242424\", endColorstr=\"#2d2d2d\", GradientType=1);\r\n    padding-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.bold {\r\n    margin-left: -5px;\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\n\r\n.about h1 {\r\n    padding-top: 30px;\r\n    text-align: center;\r\n    background-image: linear-gradient(to left, #ffffff, #6d6a70);\r\n    color: transparent;\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    font-size: 4rem;\r\n    font-weight: 400;\r\n}\r\n\r\n.about h2,\r\n.about h3 {\r\n    background-image: linear-gradient(to left, #9873bb, #9f89b4);\r\n    color: transparent;\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    text-align: center;\r\n}\r\n\r\n.about h4 {\r\n    background-image: linear-gradient(to left, #d9cfe2, #d3b5f0);\r\n    color: transparent;\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    text-align: center;\r\n    font-size: 1.2em;\r\n    line-height: 40psxx;\r\n}\r\n\r\n.about p {\r\n    color: #f1faee;\r\n    font-family: 'Cabin', sans-serif;\r\n    font-size: 1rem;\r\n}\r\n\r\n.about img {\r\n    height: 40px;\r\n}\r\n\r\n.about span {\r\n    font-family: 'Cabin', sans-serif;\r\n    font-size: 1rem;\r\n}\r\n\r\n.social,\r\n.skills-container {\r\n    padding-bottom: 40px;\r\n    box-shadow: 0 1em 1em -1em rgba(0, 0, 0, .45);\r\n    text-align: center;\r\n}\r\n\r\n.social img {\r\n    margin: 20px;\r\n}\r\n\r\n.social img:hover {\r\n    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(319deg) brightness(102%) contrast(101%);\r\n}\r\n\r\n.toast {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    background-color: rgba(137, 132, 132, 0.361) !important;\r\n    color: white;\r\n}\r\n\r\n.toast:hover {\r\n    background-color: rgba(137, 132, 132, 0.500) !important;\r\n}\r\n\r\n.toast-body img {\r\n    margin: auto;\r\n    display: block;\r\n}\r\n\r\n.toast-body span {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.skills {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n@media screen and (max-width: 850px) {\r\n\r\n    .about h1,\r\n    .about h2 {\r\n        padding-top: 2vh;\r\n    }\r\n\r\n    .about p {\r\n        font-size: 14px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
